(() => {
  function initAll(scope = document) {
    const pickers = scope.querySelectorAll('.main-product variant-selects');
    pickers.forEach(initPicker);
  }

  function initPicker(picker) {
    if (picker.dataset.progressivePickerReady === 'true') return;
    picker.dataset.progressivePickerReady = 'true';

    const rootContainer =
      picker.closest('.sticky-add-to-cart') ||
      picker.closest('.main-product') ||
      document;

    const section =
      picker.closest('.shopify-section') ||
      picker.closest('.main-product') ||
      document;

    const variantsScript = picker.querySelector('script[type="application/json"]');
    if (!variantsScript) return;

    let variants = [];
    try {
      variants = JSON.parse(variantsScript.textContent);
    } catch (error) {
      console.error('[variant-progressive] JSON variants illisible', error);
      return;
    }

    const form =
      rootContainer.querySelector('form[data-type="add-to-cart-form"]') ||
      section.querySelector('.main-product__add-to-cart form[data-type="add-to-cart-form"]');

    if (!form) return;

    const variantInput = form.querySelector('input[name="id"]');
    const addButton = form.querySelector('button[name="add"]');
    const addButtonText = addButton ? addButton.querySelector('[data-add-to-cart-text]') : null;

    const groups = Array.from(
      picker.querySelectorAll('.variant-step, .main-product__fieldset, .main-product__dropdown')
    )
      .filter((group, index, arr) => arr.indexOf(group) === index)
      .sort((a, b) => getPosition(a) - getPosition(b));

    if (!groups.length) return;

    prepareDropdownBaseLabels();
    prioritizeFramedOption();
    clearAllSelections();
    previewFramedMedia();
    forcePendingUI();
    updateState();
    showMinimumPrice();

    picker.addEventListener('change', handleChange, true);

    function showMinimumPrice() {
      const availablePrices = variants
        .filter((variant) => variant.available)
        .map((variant) => Number(variant.price))
        .filter((price) => Number.isFinite(price));

      if (!availablePrices.length) return;

      const minimumPrice = Math.min(...availablePrices);
      const formattedPrice = `€${(minimumPrice / 100)
        .toFixed(2)
        .replace('.', ',')}`;

      const priceWrapper = section.querySelector(
        '.main-product__price[data-purchase-simple]'
      );

      if (!priceWrapper) return;

      const regularPrice = priceWrapper.querySelector(
        '.price__regular .price-item--regular'
      );

      if (regularPrice) {
        regularPrice.textContent = formattedPrice;
      }

      const salePrice = priceWrapper.querySelector(
        '.price__sale .price-item--sale'
      );

      if (salePrice) {
        const amount = salePrice.querySelector('span') || salePrice;
        amount.textContent = formattedPrice;
      }
    }

    function normalizeValue(value = '') {
      return String(value)
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/\s+/g, ' ')
        .trim();
    }

    function isFramedValue(value) {
      const normalized = normalizeValue(value);
      return (
        normalized.includes('affiche + cadre') ||
        normalized.includes('affiche+cadre') ||
        (normalized.includes('affiche') && normalized.includes('cadre'))
      );
    }

    function isPosterOnlyValue(value) {
      const normalized = normalizeValue(value);
      return normalized.includes('affiche seule');
    }

    function prioritizeFramedOption() {
      const firstGroup =
        groups.find((group) => getPosition(group) === 1) || groups[0];

      if (!firstGroup || isSelectGroup(firstGroup)) return;

      const inputs = Array.from(
        firstGroup.querySelectorAll('input[type="radio"]')
      );

      const framedInput = inputs.find((input) => isFramedValue(input.value));
      const posterInput = inputs.find((input) => isPosterOnlyValue(input.value));

      if (!framedInput || !posterInput) return;

      const framedNode =
        framedInput.closest('label') ||
        framedInput.closest('.main-product__variant-option') ||
        framedInput.parentElement;

      const posterNode =
        posterInput.closest('label') ||
        posterInput.closest('.main-product__variant-option') ||
        posterInput.parentElement;

      if (
        !framedNode ||
        !posterNode ||
        framedNode === posterNode ||
        framedNode.parentNode !== posterNode.parentNode
      ) {
        return;
      }

      posterNode.parentNode.insertBefore(framedNode, posterNode);
    }

    function previewFramedMedia() {
      const framedVariant = variants.find((variant) => {
        return variant.available && isFramedValue(variant.option1);
      });

      if (!framedVariant) return;

      const mediaId =
        framedVariant.featured_media?.id ||
        framedVariant.featured_image?.id ||
        framedVariant.featured_image?.media_id;

      if (!mediaId) return;

      const gallery = section.querySelector(
        'swiper-container[id^="gallery-main-product-"]'
      );

      if (!gallery) return;

      const getSlides = () =>
        Array.from(gallery.querySelectorAll('swiper-slide[data-id]'));

      let attempts = 0;

      const moveGallery = () => {
        attempts += 1;

        const slides = getSlides();
        const slideIndex = slides.findIndex(
          (slide) => String(slide.dataset.id) === String(mediaId)
        );

        if (slideIndex >= 0 && gallery.swiper) {
          gallery.swiper.slideTo(slideIndex, 0, false);

          const thumbs = section.querySelector('.product-thumbs-swiper');
          if (thumbs?.swiper) {
            thumbs.swiper.slideTo(slideIndex, 0, false);
          }
          return;
        }

        if (attempts < 30) {
          setTimeout(moveGallery, 50);
        }
      };

      moveGallery();
    }

    function getControl(group) {
      return group.querySelector('fieldset[data-option-position], select[data-option-position]');
    }

    function getPosition(group) {
      const control = getControl(group);
      return Number(control?.dataset.optionPosition || 0);
    }

    function isSelectGroup(group) {
      return !!group.querySelector('select[data-option-position]');
    }

    function getSelectedValue(group) {
      if (isSelectGroup(group)) {
        return group.querySelector('select')?.value || '';
      }
      return group.querySelector('input[type="radio"]:checked')?.value || '';
    }

    function clearGroup(group) {
      if (isSelectGroup(group)) {
        const select = group.querySelector('select');
        if (select) select.value = '';
      } else {
        group.querySelectorAll('input[type="radio"]').forEach((input) => {
          input.checked = false;
        });
      }
    }

    function clearAllSelections() {
      groups.forEach(clearGroup);

      if (variantInput) {
        variantInput.value = '';
      }

      form.classList.add('variant-form--pending');
      section.classList.add('variant-selection-pending');
    }

    function getSelections() {
      return groups.map(getSelectedValue);
    }

    function normalizeOptionLabel(option) {
      if (!option.dataset.baseLabel) {
        option.dataset.baseLabel = option.textContent
          .replace(/\s*-\s*Indisponible\s*$/i, '')
          .replace(/^\s*-\s*Indisponible\s*$/i, '')
          .trim();
      }
      return option.dataset.baseLabel;
    }

    function prepareDropdownBaseLabels() {
      groups.forEach((group) => {
        if (!isSelectGroup(group)) return;
        const select = group.querySelector('select');
        if (!select) return;

        Array.from(select.options).forEach((option) => {
          normalizeOptionLabel(option);
        });
      });
    }

    function isValueAvailable(position, value, selections) {
      return variants.some((variant) => {
        if (!variant.available) return false;

        if (position === 1) {
          return variant.option1 === value;
        }

        if (position === 2) {
          if (!selections[0]) return false;
          return variant.option1 === selections[0] && variant.option2 === value;
        }

        if (position === 3) {
          if (!selections[0] || !selections[1]) return false;
          return (
            variant.option1 === selections[0] &&
            variant.option2 === selections[1] &&
            variant.option3 === value
          );
        }

        return false;
      });
    }

    function applyGroupState(group, selections) {
      const position = getPosition(group);
      const locked = position > 1 && !selections[position - 2];

      group.classList.toggle('variant-step--locked', locked);

      if (position > 1) {
        group.hidden = locked;
        group.style.display = locked ? 'none' : '';
      }

      if (isSelectGroup(group)) {
        const select = group.querySelector('select');
        if (!select) return;

        select.disabled = locked;

        Array.from(select.options).forEach((option) => {
          const baseLabel = normalizeOptionLabel(option);

          if (!option.value) {
            option.disabled = false;
            option.textContent = baseLabel;
            return;
          }

          const available = isValueAvailable(position, option.value, selections);
          const disabled = locked || !available;

          option.disabled = disabled;
          option.textContent = disabled ? `${baseLabel} - Indisponible` : baseLabel;
        });

        if (locked) {
          select.value = '';
        } else {
          const currentValue = select.value;
          const currentOption = Array.from(select.options).find((option) => option.value === currentValue);
          if (currentValue && currentOption && currentOption.disabled) {
            select.value = '';
          }
        }

        return;
      }

      group.querySelectorAll('input[type="radio"]').forEach((input) => {
        const label = input.closest('label');
        const available = isValueAvailable(position, input.value, selections);
        const disabled = locked || !available;

        input.disabled = disabled;

        if (label) {
          label.classList.toggle('is-disabled', disabled);
          label.setAttribute('aria-disabled', disabled ? 'true' : 'false');
        }

        if (disabled && input.checked) {
          input.checked = false;
        }
      });
    }

    function findExactVariant(selections) {
      if (selections.some((value) => !value)) return null;

      return (
        variants.find((variant) => {
          return (
            variant.option1 === (selections[0] || null) &&
            (groups.length < 2 || variant.option2 === (selections[1] || null)) &&
            (groups.length < 3 || variant.option3 === (selections[2] || null))
          );
        }) || null
      );
    }

    function forcePendingUI() {
      if (variantInput) {
        variantInput.value = '';
      }

      form.classList.add('variant-form--pending');
      section.classList.add('variant-selection-pending');

      if (addButton) {
        addButton.disabled = true;
        addButton.setAttribute('aria-disabled', 'true');
      }

      if (addButtonText) {
        addButtonText.textContent =
          addButton?.dataset.labelAdd || 'Ajouter au panier';
      }
    }

    function setPendingState() {
      forcePendingUI();
      showMinimumPrice();

      requestAnimationFrame(() => {
        forcePendingUI();
        prepareDropdownBaseLabels();
        showMinimumPrice();
      });

      setTimeout(() => {
        forcePendingUI();
        prepareDropdownBaseLabels();
        showMinimumPrice();
      }, 30);
    }

    function setVariantState(variant) {
      if (!variant) {
        setPendingState();
        return;
      }

      if (variantInput) {
        variantInput.value = variant.id;
        variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      form.classList.remove('variant-form--pending');
      section.classList.remove('variant-selection-pending');

      if (addButton) {
        addButton.disabled = !variant.available;
        addButton.setAttribute('aria-disabled', variant.available ? 'false' : 'true');
      }

      if (addButtonText) {
        addButtonText.textContent = variant.available
          ? addButton?.dataset.labelAdd || 'Ajouter au panier'
          : addButton?.dataset.labelSoldOut || 'Indisponible';
      }
    }

    function updateState() {
      const selections = getSelections();

      groups.forEach((group) => {
        applyGroupState(group, selections);
      });

      const freshSelections = getSelections();
      const variant = findExactVariant(freshSelections);

      if (freshSelections.some((value) => !value)) {
        setPendingState();
      } else {
        setVariantState(variant);
      }
    }

    function handleChange(event) {
      const target = event.target;
      if (!target.matches('input[type="radio"], select')) return;

      const currentGroup = target.closest('.variant-step, .main-product__fieldset, .main-product__dropdown');
      const currentPosition = getPosition(currentGroup);

      groups.forEach((group) => {
        if (getPosition(group) > currentPosition) {
          clearGroup(group);
        }
      });

      updateState();

      requestAnimationFrame(() => {
        updateState();
      });

      setTimeout(() => {
        updateState();
      }, 30);
    }
  }

  document.addEventListener('DOMContentLoaded', () => initAll(document));
  window.addEventListener('load', () => initAll(document));
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();